module.exports = __webpack_public_path__ + "img/connect_stop.a186b2e9.png";